/**
 * Product Feature Module
 * Hover card to set module background image from data-bg.
 */

function initFireSystemsBackgroundHover() {
  const systemsBlocks = document.querySelectorAll('.systems-block');
  if (!systemsBlocks.length) return;

  systemsBlocks.forEach((systemsBlock) => {
    const wrapper = systemsBlock.closest('.module-wrapper');
    const target = wrapper || systemsBlock;
    const originalBackgroundImage = target.style.backgroundImage;

    const cards = systemsBlock.querySelectorAll('.fire-system-card[data-bg]');
    if (!cards.length) return;

    cards.forEach((card) => {
      card.addEventListener('mouseenter', () => {
        const bg = card.dataset.bg || '';

        if (bg) {
          target.style.backgroundImage = `url("${bg}")`;
        } else {
          target.style.backgroundImage = originalBackgroundImage;
        }
      });
    });

    systemsBlock.addEventListener('mouseleave', () => {
      target.style.backgroundImage = originalBackgroundImage;
    });
  });
}

document.addEventListener('DOMContentLoaded', initFireSystemsBackgroundHover);
